export enum UserApiErrorTypes {
  AuthenticationError,
  PermissionsError,
  UpdateProfileError,
  UpdateOrganizationProfileError,
  LoadOrganizationProfileError,
  LoadOrganizationConfigError,
  SwitchOrganizationError,
}

export class UserApiError {
  constructor(public type: UserApiErrorTypes, public error: Error) {}
}
